import Ajv, { JSONSchemaType } from "ajv";
import { ScorecardObject } from "@providers/hop-ord-server/api";

const jsonSchema: JSONSchemaType<ScorecardObject> = {
  title: "Dosimetric Criterion Results",
  description: "Schema for json scorecard uploaded by dosimetrists",
  type: "object",
  properties: {
    DVHStatistics: {
      type: "array",
      items: {
        type: "object",
        properties: {
          Structure: { type: "string" },
          IsTarget: { type: "boolean", nullable: true },
          DosimetricCriteria: {
            type: "array",
            items: {
              type: "object",
              properties: {
                Criterion: { type: "string" },
                Outcome: { type: "string" },
                Actual: { type: "string" },
              },
              required: ["Criterion", "Outcome", "Actual"],
            },
          },
        },
        required: ["Structure", "DosimetricCriteria"],
      },
    },
    DVHData: {
      type: "object",
      nullable: true,
      properties: {
        DoseUnit: { type: "string" },
        DVHPointFields: {
          type: "array",
          items: { type: "string" },
        },
        Structures: {
          type: "array",
          items: {
            type: "object",
            properties: {
              StructureName: { type: "string" },
              Colour: { type: "string" },
              DVHPoints: {
                type: "array",
                items: {
                  type: "array",
                  items: { type: "number" },
                },
              },
            },
            required: ["StructureName", "Colour", "DVHPoints"],
          },
        },
      },
      required: ["DoseUnit", "DVHPointFields", "Structures"],
    },
  },
  required: ["DVHStatistics"],
};

const scorecardDataValidation = (
  jsonData: object,
): jsonData is ScorecardObject => {
  const ajv = new Ajv();
  const validate = ajv.compile(jsonSchema);
  return validate(jsonData);
};

export default scorecardDataValidation;
